export const ClientEngagementNoMatchMessage = {
  title: 'No matches? Help is on the way.',
  content:
    "We'll reach out within 1 business day or sooner to discuss your needs and find the perfect match.",
} as const;
